import { Grid } from "@mui/material";
import { BaseButton } from "../../../common/base-button/base-button";
import { CloseCircle, TickCircle } from "iconsax-react";
import "./other-information.scss";
import { t } from "i18next";

function OtherInformation({ healthTourData }) {
    //render boolean icon
    const renderBooleanIcon = condition => (condition ? <TickCircle color="var(--primary-color)" /> : <CloseCircle color="var(--red-color)" />);

    const servicesOption = [
        { id: 1, name: t("breakfast"), value: healthTourData.with_breakfast },
        { id: 2, name: t("lunch"), value: healthTourData.with_lunch },
        { id: 3, name: t("dinner"), value: healthTourData.with_dinner },
        { id: 4, name: t("transfer"), value: healthTourData.with_airport_transfer },
    ];

    const formatDate = dateString => {
        if (!dateString) {
            console.error("Invalid date string:", dateString);
            return "Invalid date";
        }
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            console.error("Invalid Date object created from:", dateString);
            return "Invalid date";
        }
        return new Intl.DateTimeFormat("fa-IR", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        }).format(date);
    };

    return (
        <Grid className="other-information" container item xs={12} rowGap={3}>
            <Grid container item xs={12} rowGap={3} columnGap={3}>
                <Grid component="span" container alignItems="center" item xs="auto">
                    {t("otherServices")}
                </Grid>

                {servicesOption.map(service => {
                    return (
                        <Grid component="span" container alignItems="center" item xs="auto" columnGap={1}>
                            {renderBooleanIcon(service?.value)} {service?.name}
                        </Grid>
                    );
                })}
            </Grid>

            <Grid container item xs={12} rowGap={1} columnGap={3}>
                <Grid className="other-information__price" container item md="auto" columnGap={2} justifyContent="center">
                    <span>{t("prePaymentAmount")}</span>
                    <span>{healthTourData?.prepayment_amount_irr} ریال</span>
                </Grid>
                <Grid className="other-information__price" container item md="auto" columnGap={2} justifyContent="center">
                    <span>{t("remainedAmount")}</span>
                    <span>{healthTourData?.remain_amount_usd}</span>
                </Grid>
            </Grid>

            <Grid
                className="other-information__payment-deadline"
                container
                item
                xs={12}
                columnGap={3}
                justifyContent={{ xs: "space-between", md: "flex-start" }}
            >
                <span>
                    <TickCircle color="var(--primary-color)" />
                </span>
                <span>{formatDate(healthTourData?.prepayment_deadline)}</span>
            </Grid>

            <Grid container item xs={12} justifyContent="flex-end">
                <Grid container item md={2}>
                    <BaseButton text={t("pay")} color="primary" size="medium" radius="radius-10" />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default OtherInformation;
